import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";
import { ListaFacturaRep } from "./list";
import { createSelector, createSelectorRx } from "keautils";
import { observeResource } from "kea-resource";
import { resources, fa } from "../../../../main/std";
import { DatosNuevoRep, validar as validarForm } from "./form";
import * as rx from "rxjs";
import { RepsSustituidos } from "./form/sustituidos";
export interface NuevoRepModalValue {
    facturas: number[];
    rep: models.NuevoRepModel;
    EsFacturaLogistica: boolean;
}

interface Props extends kea.ModalProps<NuevoRepModalValue, false | "guardar" | "timbrar"> {

}

export class NuevoRepModal extends React.PureComponent<Props> {
    debbuger
    value = (x: Props) => x.value;
    ids = createSelector(this.value, val => val.facturas);
    facturas = createSelectorRx(this.ids, ids => ids.length ? observeResource(resources.Factura.Query, {
        Ids: ids,
        EsFacturaLogistica: this.props.value.EsFacturaLogistica
    }) : rx.Observable.from([[]])
    );
    abonos = createSelector(this.value, val => val.rep.Facturas);
    sustituciones = createSelector(this.value, val=> val.rep.IdRepSustituidos);

    errores = createSelector(this.value, val => validarForm(val.rep));
    hasError = createSelector(this.errores, x => kea.validation.hasError(x));

    onRepChange = (val: models.NuevoRepModel) => {
        const old = this.props.value;
        const next: NuevoRepModalValue = {
            ...old,
            rep: val
        };
        this.props.onChange(next);
    }

    onQuitarItem = (it: models.FacturaDto) => {
        const old = this.props.value;
        const next: NuevoRepModalValue = {
            ...old,
            facturas: old.facturas.filter(x => x != it.IdRegistro),
            rep: {
                ...old.rep,
                Facturas: old.rep.Facturas.filter(x => x.IdFactura != it.IdRegistro)
            }
        };

        this.props.onChange(next);
    }

    onAbonosChange = (val: models.AbonoRepFactura[]) => {
        const old = this.props.value;
        this.onRepChange({
            ...old.rep,
            Facturas: val
        });
    }

    onSustitucionesChange = (val: number[]) => {
        const old = this.props.value.rep;
        this.onRepChange({
            ... old, 
            IdRepSustituidos: val
        })
    }

    render() {

        return (
            <kea.Modal
                title="Nuevo REP"
                onClose={() => this.props.onClose(false)}
                buttons={[
                    <kea.Button onClick={() => this.props.onClose("guardar")} disabled={this.hasError(this.props)} iconClass={fa("save")} >
                        Guardar sin timbrar
                    </kea.Button>, 
                    <kea.Button onClick={() => this.props.onClose("timbrar")} disabled={this.hasError(this.props)} iconClass={fa("bell")} style="warning" >
                        Guardar y timbrar
                    </kea.Button>,
                ]}
            >
                <DatosNuevoRep value={this.props.value.rep} onChange={this.onRepChange} />
                <kea.Tab 
                    items={[
                        {
                            title: "Abonos",
                            body: 
                            <ListaFacturaRep
                                items={this.facturas(this.props)}
                                onQuitarItem={this.onQuitarItem}
                                value={this.abonos(this.props)}
                                onChange={this.onAbonosChange}
                            />
                        }, {
                            title: "REPs sustituídos",
                            body: 
                            <RepsSustituidos 
                                value={this.sustituciones(this.props)}
                                onChange={this.onSustitucionesChange}
                                />
                        }
                    ]}
                />
                
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/facturas/pagos/index.tsx